"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function FavorTags(params) {
  var quantity = getValueOfKeyMatching(params, /favor_tags_quantity/);
  var product_size = getValueOfKeyMatching(params, /size/).replace(/\./g, '_');
  var hole_punch = parseBoolean(getValueOfKeyMatching(params, /hole/));
  var acc_ribbon = getValueOfKeyMatching(params, /ribbon/);
  this.personalization.push({
    name: 'Wording',
    value: getValueOfKeyMatching(params, /wording/)
  });
  this.favorTags.add({
    quantity: quantity,
    product_size: product_size,
    hole_punch: hole_punch,
    acc_ribbon: acc_ribbon
  });
}

module.exports = FavorTags;